import { useId, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SearchBar.css';
import { useLanguage } from '../../../LanguageContext';

export default function SearchBar() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const searchId = useId();
  const { t } = useLanguage();

  const handleSubmit = (event) => {
    event.preventDefault();
    const value = query.trim();
    if (value) navigate(`/search?q=${encodeURIComponent(value)}`);
  };

  return (
    <form className="vs-search" onSubmit={handleSubmit} role="search">
      <label className="vs-visually-hidden" htmlFor={searchId}>
        {t('Search products by part number, brand or category', 'Buscar productos por número de parte, marca o categoría')}
      </label>
      <input
        id={searchId}
        type="search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder={t('Search part, brand or category', 'Buscar parte, marca o categoría')}
        autoComplete="off"
      />
      <button type="submit" aria-label={t('Search', 'Buscar')}>
        <i className="fas fa-search" aria-hidden="true" />
      </button>
    </form>
  );
}
